module.exports = __webpack_public_path__ + "5bb650cc8279cc152ba5c73cf770bdf0.svg";